module.exports = __webpack_public_path__ + "img/1.217d7c1.png";